import React from "react";
import { useContent } from "../contexts/ContentContext";
import ConsultCTA from "./ConsultCTA";
import PracticeAreaCard from "./PracticeAreaCard";
import { usePracticeAreaModal } from "../contexts/ModalsContext";

export default function PracticeAreas() {
  const { practiceAreas: PRACTICE_AREAS } = useContent();
  const { openPracticeArea } = usePracticeAreaModal();

  return (
    <section id="practice" className="py-28 bg-[#11203c] text-white relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.6) 1px, transparent 0)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <span className="text-xs uppercase tracking-[0.3em] text-[#d4b87a]">What We Do</span>
          <h2 className="font-serif text-5xl md:text-6xl mt-4 leading-tight">
            Areas of <span className="italic text-[#a8c4dc]">Practice</span>
          </h2>
          <div className="h-px w-14 bg-[#b8924a] mt-6" />
          <p className="text-stone-300 text-lg mt-6 leading-relaxed">
            Comprehensive counsel across a wide range of legal disciplines, delivered by attorneys
            who know Idaho and care about its people. Select an area to meet the attorneys who
            handle it.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {PRACTICE_AREAS.map((area) => (
            <PracticeAreaCard
              key={area.id}
              area={area}
              attorneyCount={(area.attorneys || []).length}
              onClick={() => openPracticeArea(area.id)}
            />
          ))}
        </div>

        <ConsultCTA variant="dark" source="Home page — Practice Areas section" body="Need counsel in one of these areas? Let's talk." />
      </div>
    </section>
  );
}
